// Currency Converter for Clarity Conscious
// Automatically converts prices based on visitor's country

document.addEventListener("DOMContentLoaded", function() {
  console.log("Currency Converter Initialized");
  
  // Currency conversion rates (relative to USD)
  const conversionRates = {
    USD: 1.00,
    EUR: 0.92,
    GBP: 0.79,
    CAD: 1.36,
    AUD: 1.51,
    INR: 83.42,
    JPY: 154.75,
    CNY: 7.24,
    BRL: 5.14,
    MXN: 16.75,
    ZAR: 18.42,
    RUB: 92.50,
    SGD: 1.34,
    NZD: 1.64,
    CHF: 0.90,
    HKD: 7.82,
    ILS: 3.68,
    MYR: 4.70,
    KRW: 1370.00,
    AED: 3.67,
    CZK: 22.85,
    DKK: 6.85,
    NOK: 10.45,
    PLN: 4.02,
    SEK: 10.62
  };

  // Currency symbols
  const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'CA$',
    AUD: 'A$',
    INR: '₹',
    JPY: '¥',
    CNY: '¥',
    BRL: 'R$',
    MXN: 'MX$',
    ZAR: 'R',
    RUB: '₽',
    SGD: 'S$',
    NZD: 'NZ$',
    CHF: 'CHF',
    HKD: 'HK$',
    ILS: '₪',
    MYR: 'RM',
    KRW: '₩',
    AED: 'د.إ',
    CZK: 'Kč',
    DKK: 'kr',
    NOK: 'kr',
    PLN: 'zł',
    SEK: 'kr'
  };

  // Country to currency mapping
  const countryCurrencyMap = {
    US: 'USD',
    CA: 'CAD',
    GB: 'GBP',
    AU: 'AUD',
    NZ: 'NZD',
    IN: 'INR',
    JP: 'JPY',
    CN: 'CNY',
    BR: 'BRL',
    MX: 'MXN',
    ZA: 'ZAR',
    RU: 'RUB',
    SG: 'SGD',
    CH: 'CHF',
    HK: 'HKD',
    IL: 'ILS',
    MY: 'MYR',
    KR: 'KRW',
    AE: 'AED',
    CZ: 'CZK',
    DK: 'DKK',
    NO: 'NOK',
    PL: 'PLN',
    SE: 'SEK',

    // European countries using EUR
    DE: 'EUR',
    FR: 'EUR',
    IT: 'EUR',
    ES: 'EUR',
    NL: 'EUR',
    BE: 'EUR',
    AT: 'EUR',
    IE: 'EUR',
    PT: 'EUR',
    GR: 'EUR',
    FI: 'EUR'
  };

  // (All your other functions remain unchanged below this line)

  async function detectUserCountry() {
    try {
      const response = await fetch('https://ipapi.co/json/', { mode: 'cors' });
      const data = await response.json();
      // ipapi.co returns country_code
      if (data.country_code) {
        return data.country_code;
      }
      throw new Error('ipapi.co failed to return country code');
    } catch (error) {
      console.error('Error detecting country:', error);
      // Fallback to a different service if the first one fails
      try {
        const fallbackResponse = await fetch('https://ipinfo.io/json');
        const fallbackData = await fallbackResponse.json();
        // ipinfo.io returns country
        if (fallbackData.country) {
          return fallbackData.country;
        }
        throw new Error('ipinfo.io failed to return country code');
      } catch (fallbackError) {
        console.error('Error detecting country with fallback:', fallbackError);
        return 'US'; // Default to US if all detection fails
      }
    }
  }

  function convertPrice(priceInUSD, targetCurrency) {
    if (!conversionRates[targetCurrency]) {
      return { amount: priceInUSD, currency: 'USD', symbol: '$' };
    }
    
    const convertedAmount = priceInUSD * conversionRates[targetCurrency];
    const roundedAmount = Math.round(convertedAmount * 100) / 100;
    
    return {
      amount: roundedAmount,
      currency: targetCurrency,
      symbol: currencySymbols[targetCurrency] || '$'
    };
  }

  function updatePriceDisplays(currency) {
    const basePrice = 28;
    const convertedPrice = convertPrice(basePrice, currency);
    const valuePrices = {
      2144: convertPrice(2144, currency),
      2116: convertPrice(2116, currency),
      497: convertPrice(497, currency),
      297: convertPrice(297, currency),
      347: convertPrice(347, currency),
      197: convertPrice(197, currency),
      167: convertPrice(167, currency),
      147: convertPrice(147, currency)
    };
    
    const priceElements = document.querySelectorAll('.offer-price');
    priceElements.forEach(element => {
      if (element.textContent.includes('2,144')) {
        element.textContent = `${valuePrices[2144].symbol}${valuePrices[2144].amount}`;
      } else {
        element.textContent = `${convertedPrice.symbol}${convertedPrice.amount}`;
      }
      element.setAttribute('data-currency', currency);
    });

    const otherPriceElements = document.querySelectorAll('.price-display:not(.offer-price)');
    otherPriceElements.forEach(element => {
      const text = element.textContent;
      if (text.includes('2,144')) {
        element.textContent = `${valuePrices[2144].symbol}${valuePrices[2144].amount}`;
      } else if (text.includes('$497')) {
        element.textContent = text.replace(/\$497/g, `${valuePrices[497].symbol}${valuePrices[497].amount}`);
      } else if (text.includes('$297')) {
        element.textContent = text.replace(/\$297/g, `${valuePrices[297].symbol}${valuePrices[297].amount}`);
      } else if (text.includes('$347')) {
        element.textContent = text.replace(/\$347/g, `${valuePrices[347].symbol}${valuePrices[347].amount}`);
      } else if (text.includes('$197')) {
        element.textContent = text.replace(/\$197/g, `${valuePrices[197].symbol}${valuePrices[197].amount}`);
      } else if (text.includes('$167')) {
        element.textContent = text.replace(/\$167/g, `${valuePrices[167].symbol}${valuePrices[167].amount}`);
      } else if (text.includes('$147')) {
        element.textContent = text.replace(/\$147/g, `${valuePrices[147].symbol}${valuePrices[147].amount}`);
      } else if (text.includes('$28')) {
        element.textContent = text.replace(/\$28/g, `${convertedPrice.symbol}${convertedPrice.amount}`);
      }
      element.setAttribute('data-currency', currency);
    });

    const textElements = document.querySelectorAll('[data-contains-price="true"]');
    textElements.forEach(element => {
      const originalText = element.getAttribute('data-original-text') || element.textContent;
      if (!element.getAttribute('data-original-text')) {
        element.setAttribute('data-original-text', originalText);
      }
      
      let newText = originalText;
      newText = newText.replace(/\$28/g, `${convertedPrice.symbol}${convertedPrice.amount}`);
      newText = newText.replace(/\$2,144/g, `${valuePrices[2144].symbol}${valuePrices[2144].amount}`);
      newText = newText.replace(/\$2,116/g, `${valuePrices[2116].symbol}${valuePrices[2116].amount}`);
      newText = newText.replace(/\$497/g, `${valuePrices[497].symbol}${valuePrices[497].amount}`);
      newText = newText.replace(/\$297/g, `${valuePrices[297].symbol}${valuePrices[297].amount}`);
      newText = newText.replace(/\$347/g, `${valuePrices[347].symbol}${valuePrices[347].amount}`);
      newText = newText.replace(/\$197/g, `${valuePrices[197].symbol}${valuePrices[197].amount}`);
      newText = newText.replace(/\$167/g, `${valuePrices[167].symbol}${valuePrices[167].amount}`);
      newText = newText.replace(/\$147/g, `${valuePrices[147].symbol}${valuePrices[147].amount}`);
      element.textContent = newText;
    });

    document.querySelectorAll('*:not(script):not(style)').forEach(element => {
      if (element.childNodes && element.childNodes.length > 0) {
        element.childNodes.forEach(node => {
          if (node.nodeType === 3) {
            const text = node.nodeValue;
            if (text && (text.includes('$28') || text.includes('$2,144') || 
                text.includes('$497') || text.includes('$297') || 
                text.includes('$347') || text.includes('$197') || 
                text.includes('$167') || text.includes('$147'))) {
              if (!element.hasAttribute('data-original-price-text')) {
                element.setAttribute('data-original-price-text', text);
              }
              let newText = text;
              newText = newText.replace(/\$28/g, `${convertedPrice.symbol}${convertedPrice.amount}`);
              newText = newText.replace(/\$2,144/g, `${valuePrices[2144].symbol}${valuePrices[2144].amount}`);
              newText = newText.replace(/\$2,116/g, `${valuePrices[2116].symbol}${valuePrices[2116].amount}`);
              newText = newText.replace(/\$497/g, `${valuePrices[497].symbol}${valuePrices[497].amount}`);
              newText = newText.replace(/\$297/g, `${valuePrices[297].symbol}${valuePrices[297].amount}`);
              newText = newText.replace(/\$347/g, `${valuePrices[347].symbol}${valuePrices[347].amount}`);
              newText = newText.replace(/\$197/g, `${valuePrices[197].symbol}${valuePrices[197].amount}`);
              newText = newText.replace(/\$167/g, `${valuePrices[167].symbol}${valuePrices[167].amount}`);
              newText = newText.replace(/\$147/g, `${valuePrices[147].symbol}${valuePrices[147].amount}`);
              node.nodeValue = newText;
            }
          }
        });
      }
    });

    console.log(`Prices updated to ${currency}: ${convertedPrice.symbol}${convertedPrice.amount}`);
  }

  async function initCurrencyConverter() {
    try {
      const countryCode = await detectUserCountry();
      const currency = countryCurrencyMap[countryCode] || 'USD';
      window.clarityUserCountry = countryCode;
      window.clarityCurrency = currency;
      updatePriceDisplays(currency);
      console.log(`Currency set to ${currency} based on country ${countryCode}`);
    } catch (error) {
      console.error('Error initializing currency converter:', error);
    }
  }

  initCurrencyConverter();
});
